<template>
    <div class='confirmBox'>
        <!-- <Echarts/> -->
        <el-row class="confirmCenter">
            <el-col class="borde">
                <div >
                    <el-col class="bordeLeft">待审核订单</el-col>
                </div>
            </el-col>
        </el-row>
        <!-- table -->
        <div class="table">
          <el-row >
            <el-col :span="24" v-if="showCon">
                
                <el-col :span='24' class="confirmBot" v-loading="false">
                        <el-table
                        ref="multipleTable"
                        :data="tableData"
                        tooltip-effect="dark"
                        style="width: 100%"
                        :header-cell-style="tableHeaderColor"
                        >
                          <el-table-column
                            label="序号"
                            min-width="5%"
                            type="index"
                            >
                        </el-table-column>

                        <el-table-column
                            prop="merchCode"
                            min-width="10%"
                            label="渠道号"
                        >
                        </el-table-column>
                        <el-table-column
                            prop="orderId"
                            label="订单号"
                            min-width="10%"
                            show-overflow-tooltip>
                        </el-table-column>
                        <el-table-column
                            prop="billNum"
                            label="票据号码"
                            min-width="10%"
                            >
                        </el-table-column>
                        <el-table-column
                            prop="acceptingBank"
                            label="承兑人"
                            min-width="10%"
                            >
                        </el-table-column>

                        <el-table-column
                            prop="billAmt"
                            label="票面金额"
                            min-width="10%"
                            >
                        </el-table-column>
                        <el-table-column
                            prop="endDate"
                            label="到期日"
                            min-width="10%"
                            >
                        </el-table-column>
                        <el-table-column
                            prop="acceptType"
                            label="类型"
                            min-width="10%"
                            >
                            <template slot-scope="scope">
                              <el-select v-model="scope.row.acceptType" placeholder="请选择">
                                <el-option
                                  v-for="item in options"
                                  :key="item.value"
                                  :label="item.label"
                                  :value="item.value">
                                </el-option>
                              </el-select>
                            </template>
                        </el-table-column>

                        <el-table-column
                            label="票面图片"
                            min-width="10%"
                            >
                            <template slot-scope="scope">
                                <div
                                @click="showPicture(scope.row)"
                                class="showPic"
                                >
                                点击可查看大图
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="result"
                            label="审核结果"
                            min-width="15%"
                            >
                            <!-- <el-button type="text" size=small class="rejectBtn" @click="Reject = true">驳回</el-button> -->
                            <!-- <el-button type="text" size=small class="rejectBtn" @click="Reject = true">驳回</el-button> -->
                            <template slot-scope="scope">
                                <el-button
                                @click.native.prevent="rejectClick(scope.row.orderId)"
                                type="text"
                                size=small 
                                class="rejectBtn"
                                >
                                驳回
                                </el-button>
                                <el-button type="primary" @click.native.prevent="passClick(scope.row)" size="small">通过</el-button>
                            </template>
                            <!-- <el-button type="primary" @click="passDialogVisible = true" size="small">通过</el-button> -->
                        </el-table-column>
                        <el-table-column
                            prop="zip"
                            label="备注"
                            min-width="10%"
                            >
                            <!-- <el-button type="text" @click="detailClick">详情</el-button> -->
                            <!-- <template slot-scope="scope">
                                <el-button
                                @click.native.prevent="deleteRow(scope.$index,scope)"
                                type="text"
                                size="small">
                                操作
                                </el-button>
                            </template> -->
                            <template slot-scope="scope">
                                <el-button
                                @click.native.prevent="detailClick(scope.row.orderId)"
                                type="text"
                                >
                                详情
                                </el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-col>
            </el-col>
        </el-row>
        </div>
        <!-- pagination -->
        <div class="pagination">
          <el-pagination
            background
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage"
            layout="prev, pager, next"
            prev-text="上一页"
            next-text="下一页"
            :page-size="pagesize"
            :total=this.totalPage>
          </el-pagination>
        </div>

        <el-dialog
          :visible.sync="passDialogVisible"
          width="30%"
          >
          <span>订单已通过审核</span>
          <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="passDialogVisibleClick">确 定</el-button>
          </span>
        </el-dialog>
        
        <el-dialog
          title="请填写驳回原因"
          :visible.sync="Reject"
          width="30%"
          center
          class="rejectHeader"
          :before-close="handleClose">
              <el-input
                type="textarea"
                autosize
                placeholder="在这里写下驳回的理由"
                v-model="textarea1">
              </el-input>

              
          <span slot="footer" class="dialog-footer">
            <el-button @click="Reject = false">取 消</el-button>
            <el-button type="primary" @click=waitConfirmReject()>确 定</el-button>
          </span>
        </el-dialog>

        <el-dialog
          title="订单详情"
          :visible.sync="dialogVisible"
          width="30%"
          :before-close="handleClose">
            <div>
              <div>订单号：{{this.detailData.orderId}}</div>
              <div>卖方主体：{{this.detailData.cmpName}}</div>
              <div>卖方姓名：{{this.detailData.userName}}</div>
              <div>卖方手机号：{{this.detailData.mobile}}</div>
            </div>
          <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
          </span>
        </el-dialog>

        <el-dialog :visible.sync="picturedialogVisible">
            <div class="billFront">票据正面</div>
            <img width="100%" :src=this.billFrontPicture>
            <div class="billBack">票据背面</div>
            <img width="100%" :src="this.billBackPicture">
        </el-dialog>
    </div>
</template>

<script>

export default {

    data(){
        return{
            testData: [{
            orderNumber:'1',
            name: '4223',
            bill:'O2020022842231430123',
            six:'2220000000000000001111111111111',
            receive:'我是承兑人有限公司可换行',
            thousand:'500,000.00元',
            date:'2021-02-28',
            // picture:'点击图片可查看大图',
            result:'/',
            visible: false,
            }],
            tableData: [],
            loading:true,
            dialogVisible:false,
            Reject:false,
            showCon:true,
            textarea1: '',
            passDialogVisible: false,
            detailData:'',
            rejectId:'',
            passId:'',
            billType:'',
            picturedialogVisible:false,
            billFrontPicture:'',
            billBackPicture:'',
            totalPage:0,
            currentPage:1,
            pagesize:10,
            options: [{
                  value: '国股',
                  label: '国股'
                }, {
                  value: '大商',
                  label: '大商'
                }, {
                  value: '城商',
                  label: '城商'
                }, {
                  value: '三农',
                  label: '三农'
                }, {
                  value: '村镇',
                  label: '村镇'
            },{
                  value: '外资',
                  label: '外资'
                }, {
                  value: '民营',
                  label: '民营'
                }, {
                  value: '财票',
                  label: '财票'
            }],
        }
    },

    mounted(){
        this.handleAjax(this.currentPage)
        if(this.$route.query.code&&this.$route.query.code==1){
            this.dialogVisible=!this.dialogVisible
        }
    },
    methods:{
      handleCurrentChange(val) {
            this.handleAjax(val);
      },
      // 点击通过按钮
      passClick(val){
        this.passDialogVisible = true
        this.passId = val.orderId
        this.billType=val.acceptType
      },
      // 点击通过确定按钮
      passDialogVisibleClick(){
        this.passDialogVisible = false
        let testId = this.passId
        this.confirmPass(testId)
      },
      // 通过按钮函数
      confirmPass(value){
      this.ajax.post('/bill/orderpass',{bizContent:{orderId:value,billType:this.billType}})
      .then(
        result=>{
          if(result.data.status=='0000'){
            this.currentPage=1;
            this.handleAjax(this.currentPage)
            // this.isremindok=false
            // this.statecapture()
            // swal({
            //   text: '已成功通过',
            //   icon:'success',
            //   timer: 3000,
            //   buttons: false
            // })
          }
          else{
            // swal({
            //   text: result.data.message,
            //   timer: 3000,
            //   buttons: false
            // })
          }
        }
      )
      
    },
      // 点击驳回按钮
      rejectClick(val){
        this.Reject = true
        this.rejectId = val

      },
      // 点击驳回确定按钮
      waitConfirmReject(){
        this.Reject = false
        let testId = this.rejectId
        this.confirmReject(testId)
      },

      // 驳回函数
      confirmReject(value){
      this.ajax.post('/bill/orderreject',{bizContent:{orderId:value,rejectdesc:this.textarea1}})
      .then(
        result=>{
          if(result.data.status=='0000'){
            this.currentPage=1;
            this.handleAjax(this.currentPage)
            // this.statecapture()
            // this.isremindno=false
            // swal({
            //   text: '驳回成功',
            //   icon:'success',
            //   timer: 3000,
            //   buttons: false
            // })
          }
          else{
            // swal({
            //   text: result.data.message,
            //   timer: 3000,
            //   buttons: false
            // })
          }
        }
      )
      
    },
      
       showPicture(val){
        this.picturedialogVisible = true
        this.billFrontPicture = val.billFrontUrl
        this.billBackPicture = val.billBackUrl
       },

       tableHeaderColor({ row, column, rowIndex, columnIndex }) {
          if (rowIndex === 0) {
            return 'background-color: rgba(244,244,244,1);color: rgba(51,51,51,1);font-weight: bold;font-size:14px; height:55px;'
          }
        },

      handleClose(done) {
        this.$confirm('确认关闭？')
          .then(_ => {
            done();
          })
          .catch(_ => {});
        },
        closeChangePrice(){
          this.ChangePrice = false
      },
        handleGjClick(){
          this.ChangePrice = true
        },
        // 票据列表请求数据
        handleAjax(val){
            this.loading=true
            this.ajax.post('/jyOder/jyOrderList',{bizContent:{currentPage:val,pageSize:this.pagesize,statusType:'待审核订单',merchCode:''}})
                .then(
                    result=>{
                        if(result.data.status=='0000'){ 
                            let add = result.data.data.data
                            // add.map((item,index)=>{
                            //     add[index].xh=index+1
                            // })
                            this.tableData=add
                            this.tableData.forEach((item) => {
                              if(item.status == 100) {
                                item.status = '待审核'
                              }else if(item.status == 600) {
                                item.status = '待背书'
                              }else if(item.status == 610 || 620 || 630) {
                                item.status = '待签收'
                              }
                            })
                            this.totalPage = result.data.data.pages
                            if(this.radio2=='0'){
                                if(this.tableData.length==0){
                                    this.showCon=false
                                    //下面是修改后的代码，为了让表格显示出来
                                    // this.showCon=true
                                }else{
                                    this.showCon=true
                                }
                            }
                            this.loading=false
                        }else{
                            }
                        }
                )
        },
        // 点击详情按钮
        detailClick(val){
          this.dialogVisible = true
          this.handleDetailAjax(val)
        },
        // 票据详情请求数据
        handleDetailAjax(value){
            this.loading=true
            this.ajax.post('/jyOder/jyorderDetail',{bizContent:{orderId:value}})
                .then(
                    result=>{
                        if(result.data.status=='0000'){
                            let add = result.data.data
                            this.currentPage=1;
                            this.handleAjax(this.currentPage)
                            // 这个请求页的部分不是所有的数据请求都需要的
                            // add.map((item,index)=>{
                            //     add[index].xh=index+1
                            // })
                            this.detailData=add
                            this.total=result.data.total
                            if(this.radio2=='0'){
                                if(this.detailData.length==0){
                                    this.showCon=false
                                    //下面是修改后的代码，为了让表格显示出来
                                    // this.showCon=true
                                }else{
                                    this.showCon=true
                                }
                            }
                            this.loading=false
                        }else{
                            }
                        }
                )
              
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },


        handleRowClick(val){
            this.$router.push({
                name:'orderInfor',
                query:{
                    oid:val.orderId
                }
            })
        },
      
        // handleClose(done) {
        //     this.$confirm('确认关闭？')
        //     .then(_ => {
        //         done();
        //         this.handleAjax()
        //     })
        //     .catch(_ => {});
        // },

    }
}
</script>

<style  scoped>
.confirmBox{
    background: white;
    height: 883px;
}

.table{
  background:rgba(255,255,255,1);
  padding-left: 31px;
  padding-right: 38px;
}

.confirmBot{
     height: auto;
     height: 682px;
     background: white;
     box-shadow:0px 3px 15px 0px rgba(0,0,0,0.06);
     border-radius:8px;
}

.pagination{
  height: 111px;
  text-align: center;
  padding-top: 50px;
  box-sizing: border-box;
}

.confirmBot>>>.cell{
    font-size: 14px;
    text-align: center;
    font-weight: 400;
    color:rgba(51,51,51,1);
    font-family:PingFangSC-Regular,PingFang SC;
}

.button{
    padding: 12px 5px;
    border-radius: unset;
    height: 34px;
    color: #1884FC; 
    background: white;
}

.line{
  width: 920px;
  height: 1px;
  box-sizing: border-box;
  background: #E3E4E5;
  margin-left: 14px;
  margin-right: 13px;
  margin-bottom: 21px;
}

.borde{
    height: 90px;
    padding-left: 34px;
    padding-top: 38px;
}
.bordeLeft{
    width:120px;
    height:33px;
    font-size:24px;
    font-family:PingFangSC-Regular,PingFang SC;
    font-weight:400;
    color:rgba(0,0,0,1);
    line-height:33px;
}
.bordeRight{
    text-align: right;
    padding-right: 20px;
}

.rejectBtn{
  width:56px;
  border-radius:4px;
  color: #2B89EB;
  text-align: center;
  border:1px solid #2B89EB;
}

.rejectDetail{
  border: none;
}

.rejectHeader{
  font-size:14px;
  font-family:PingFangSC-Medium,PingFang SC;
  font-weight:500;
  color:rgba(51,51,51,1);
}

.showPic{
  color: #8C8CFF;
}

.billFront, .billBack{
  text-align: center;
  font-size: 20px;
}
</style>


// WEBPACK FOOTER //
// src/page/orderexception/waitconfirm.vue